module.exports = __webpack_public_path__ + "static/media/oddish.e15d418e.jpg";